import { useDispatch, useSelector } from "react-redux";

import { Downtime } from "./types";
import { fetchDowntimeStart } from "./slice";
import { useEffect } from "react";
import { ReduxState } from "../rootReducer";

export const useDowntime = (): Downtime => {
  const dispatch = useDispatch();
  const downtime = useSelector((state: ReduxState) => state.downtime);
  const OneMinute = 60 * 1000;

  useEffect(() => {
    dispatch(fetchDowntimeStart());
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchDowntimeStart());
    }, OneMinute);
    return () => clearInterval(interval);
  }, [dispatch, OneMinute]);

  return downtime;
};
